import { ChangeDetectionStrategy, Component } from "@angular/core";
import { PagingService } from "src/app/services/paging.service";

import { FooterComponent } from "../footer/footer.component";
import { IsFeatureAppDirective } from "../../../directives/is-feature-app.directive";
import { FooterPopupComponent } from "../footer-popup/footer-popup.component";
import { FooterServiceLinkComponent } from "../footer-service-link/footer-service-link.component";

@Component({
  selector: "app-footer-base",
  templateUrl: "./footer-base.component.html",
  styleUrls: [],
  imports: [
    FooterComponent,
    IsFeatureAppDirective,
    FooterPopupComponent,
    FooterServiceLinkComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterBaseComponent {
  constructor(public pagingService: PagingService) {}
}
